module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de8cb37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 255
// module chunks = 5